<template>
    <div>
        <div
            class="d-flex flex-justify-between flex-align-center cursor-pointer rotate90 hover-expand"
            @click="open = !open"
        >
            <i class="icon-cr icon-menu-hamburger mr-2"></i>
            <span class="text-uppercase hidden-sm-down">Menu</span>
        </div>
        <div id="sidebar-content" :class="{ open: open }" class="pt">
            <ul class="menu-items overflow-hidden">
                <li class="mb-5">
                    <a class="d-flex flex-justify-between flex-align-baseline" @click="hide"
                        ><span class="text-uppercase text-bold">Fechar </span
                        ><i class="icon-cr icon-close mr-3"></i
                    ></a>
                </li>
                <li v-for="item in menuLinks">
                    <a @click="$emit('scroll-to', item.anchor)" class="">{{ item.name }} </a>
                    <!-- TODO adicionar subitems do menu -->
                    <hr class="mr-3" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        el: '#origins-menu-vue',

        name: 'OriginsMenu',

        props: {
            menuLinks: Array,
        },

        data() {
            return {
                open: false,
                selectedTab: null,
                isMobile: false,
                sidebarWidth: '250px',
            };
        },

        methods: {
            hide() {
                this.open = false;
            },
        },
    };
</script>
